import { createContext } from 'react';
export const AuthedI18nContext = /*#__PURE__*/createContext({
  i18nLoader: null
});
export const PublicI18nContext = /*#__PURE__*/createContext({
  i18nLoader: null
});